import { THealthDomainWithOverall } from '@/types/Health.types';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import useTelemetry from '@/providers/TelemetryProvider/useTelemetry';
import { mixpanelEvents } from '@/constants/mixpanel';
import queryKeys from '@/constants/queryKeys';
import { completeGoalPatch } from '@/services/api/requests/growthZone';

const useCompleteGoal = (domain: THealthDomainWithOverall, onSuccessCallback?: () => void) => {
  const toast = useToast();
  const { trackEvent } = useTelemetry();

  const { isPending, isSuccess, mutate } = useMutation({
    mutationKey: [queryKeys.growthZone.completeGoal],
    mutationFn: async (goalId: string) => {
      await completeGoalPatch(goalId);
    },
    onSuccess: () => {
      onSuccessCallback?.();

      trackEvent(mixpanelEvents.GOAL_COMPLETED, { domain });
    },
    onError: (error) => {
      toast({
        status: 'error',
        title: 'Error completing a goal',
        description: error instanceof Error ? error.message : 'An unexpected error occurred.',
      });
    },
  });

  return {
    isPending,
    mutate,
    isSuccess,
  };
};

export default useCompleteGoal;
